import request from '@/utils/request'
import API from './api'

/*题包查看*/

// 获取章节教辅列表
export const getAssistListAPI = (data) => {
	return request({
		url: API.GET_NO_SUBJECT_ASSIST_LIST,
	    method: 'post',
	    data
	});
}

// 获取树节点(章节&知识点)
export const getTreeListAPI = (data) => {
	return request({
		url: API.GET_TREE_LIST,
	    method: 'post',
	    data
	});
}

// 获取题目列表
export const getQuestionListAPI = (data) => {
  return request({
    url: API.QUESTION_BY_ID,
      method: 'post',
      data
  });
}

// 章节查看题包
export const getPackageListAPI = (data) => {
  return request({
    url: API.LOOK_UP_PACKAGE,
      method: 'post',
      data
  });
}

// 获取题目列表（章节）
export const getTopicListAPI = (data) => {
  return request({
    url: API.GET_QUESTION_LIST,
      method: 'post',
      data
  });
}

// 删除关联
export const deleteRelateAPI = (data) => {
  return request({
    url: API.DELETE_RELATE,
      method: 'post',
      data
  });
}

/*题包查看end*/

//题包管理-视频题包-题包列表
export function getQuestionPackageListAPI(data) {
  return request({
    url: API.QUESTION_PACKAGE_LIST,
    method: 'post',
    data
  })
}

//题包管理-视频题包-更新题包状态
export function modifyQuestionPackageStatusAPI(modifyType,data) {
  let url=''
  switch (modifyType){
  	case 'generalize':
  		url=API.GENERALIZE_QUESTION_PACKAGE
  		break;
  	case 'submit':
  		url=API.SUBMIT_QUESTION_PACKAGE
  		break;
  	case 'upTest':
  		url=API.UPTEST_QUESTION_PACKAGE
  		break;
  	case 'upline':
  		url=API.UPLINE_QUESTION_PACKAGE
  		break;
  	case 'offline':
  		url=API.OFFLINE_QUESTION_PACKAGE
  		break;
  	default:
  		break;
  }
  
  return request({
    url,
    method: 'post',
    data
  })
}


//题包管理-视频题包-创建题包
export function editQuestionPackageAPI(data) {
  return request({
    url: API.EDIT_QUESTION_PACKAGE,
    method: 'post',
    data
  })
}

//题包管理-视频题包-题包详情
export function getQuestionPackageDetailAPI(data) {
  return request({
    url: API.QUESTION_PACKAGE_DETAIL,
    method: 'post',
    data
  })
}
//题包管理-视频题包-题包题目
export function getQuestionPackageQuestionAPI(data) {
  return request({
    url: API.QUESTION_PACKAGE_QUESTION,
    method: 'post',
    data
  })
}
//题包管理-视频题包-题包章节
export function getQuestionPackageChapterAPI(data) {
  return request({
    url: API.QUESTION_PACKAGE_CHAPTER,
    method: 'post',
    data
  })
}


//题包管理-视频题包-题包关联题目、章节
export function bindRelationAPI(data) {
  return request({
    url: API.QUESTION_PACKAGE_BIND_RELATION,
    method: 'post',
    data
  })
}


//题包管理-视频题包-录入人列表
export function getEntryUserListAPI(data) {
  return request({
    url: API.ENTRY_USER_LIST,
    method: 'post',
    data
  })
}

//题包管理-视频题包-删除关联题目、章节、知识点
export function deleteQuestionPackageBindAPI(data) {
  return request({
    url: API.DELETE_QUESTION_PACKAGE_BIND,
    method: 'post',
    data
  })
}



/*****人工精选题包*****/
//题包管理-人工精选题包-人员列表
export function getGoodPackageUserListAPI(data) {
  return request({
    url: API.GOOD_PACKAGE_USER_LIST,
 	method: 'post',
    data
  })
}


//题包管理-人工精选题包-任务列表
export function getGoodPackageListAPI(data) {
  return request({
    url: API.GOOD_PACKAGE_LIST,
	method: 'post',
    data
  })
}


//题包管理-人工精选题包-修改任务状态：提交、返工、入库、上线、上测试、删除
export function modifyGoodPackageStatusAPI(stage_type,modifyType,data) {
    let url='',
  	actionKey=`${stage_type}_${modifyType}`,
 	urlMap={
	  	'selecting_submit':API.GOOD_PACKAGE_SELECTING_SUBMIT,//选精中-提交
	  	'selecting_delete':API.GOOD_PACKAGE_SELECTING_DELETE,//选精中-删除
	  	'checking_submit':API.GOOD_PACKAGE_CHECKING_SUBMIT,//审核中-提交
	  	'checking_rework':API.GOOD_PACKAGE_CHECKING_REWORK,//审核中-返工
	  	'rework_submit':API.GOOD_PACKAGE_REWORK_SUBMIT,//返工-提交
	  	'check_finish_storage':API.GOOD_PACKAGE_CHECK_FINISH_STORAGE,//审核完成-入库任务
	  	'storage_upline':API.GOOD_PACKAGE_STORAGE_UPLINE,//已入库-上线
	  	'storage_upTest':API.GOOD_PACKAGE_STORAGE_UPTEST,//已入库-上测试
	  }
  if(actionKey=='storage_upTest'){data.preview_type=1}
  return request({
    url: urlMap[actionKey],
    method: 'post',
    data
  })
}



//题包管理-人工精选题包-分类获取教辅
export function getTypeAssistListAPI() {
  return request({
    url: API.TYPE_ASSIST_LIST,
	method: 'post'
  })
}


//题包管理-人工精选题包-根据精题包章节获取其他章节
export function getOtherInitSectionAPI(data) {
  return request({
    url: API.OTHER_INIT_SECTION,
	method: 'post',
    data
  })
}

//题包管理-人工精选题包-创建任务前检查
export function checkSectionUsedAPI(data) {
  return request({
    url: API.CHECK_SECTION_USED,
	method: 'post',
    data
  })
}
//题包管理-人工精选题包-创建任务
export function createGoodPackageTaskAPI(data) {
  return request({
    url: API.CREATE_GOOD_PACKAGE_TASK,
	method: 'post',
    data
  })
}


//题包管理-人工精选题包-人员分配
export function assignGoodPackageUserAPI(data,assignType) {
  let url=assignType=='select_user'?API.ASSIGN_GOOD_PACKAGE_SELECT_USER:API.ASSIGN_GOOD_PACKAGE_CHECK_USER
  return request({
    url,
	method: 'post',
    data
  })
}

// 人工精题包-详情api
// 修改排序值
export function modifySortValueAPI(data) { 
  return request({
    url: API.MODIFY_SORT_VALUE,
    method: 'post',
    data
  })
}



// 返工题目
export function getRewordQuestionAPI(data) { 
  return request({
    url: API.QEUESTION_PACKAGE_REWORK,
    method: 'post',
    data
  })
}

// 操作题目（选中/移除题目）
export function optionQuestionAPI(data) { 
  return request({
    url: API.OPTION_QUESTION,
    method: 'post',
    data
  })
}

// 通过题目
export function getPassQuestionAPI(data) { 
  return request({
    url: API.OPTION_PASS_QUESTION,
    method: 'post',
    data
  })
}

// 题目列表
export function getQuestionPackageAPI(data) { 
  return request({
    url: API.GET_PACKAGE_QUESTION_LIST,
    method: 'post',
    data
  })
}




// 题目筛选项目
export function getFilterQuestionAPI(data) { 
  return request({
    url: API.GET_QUESTION_FILTER_LIST,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/API/question-package.js